import React, { useMemo } from 'react';
import {
  DeleteAllFiles,
  ErrorText,
  FileName,
  FilePlateBox,
  FilePlateCloseButton,
  FilePlateWrap,
  TotalFilesInfo,
} from './FilePlateStyled';
import { FilePlatePreviewIcon } from './FilePlatePreviewIcon';
import { Space } from '@gr-monorepo/common/ui';

export type FilePlateProps = {
  files: {
    file: { name: string; size: number };
    isLoading?: boolean;
    loadingProgress?: number;
    isErrored?: boolean;
    operationId: number;
  }[];
  onRemove?: (index: number | null) => void;
  errors?: string[];
};

const bytesInMiB = 1024 * 1024;

const pluralizeFiles = (count: number): string => {
  const forms = ['файл', 'файла', 'файлов'];
  if (count % 10 === 1 && count % 100 !== 11) return forms[0];
  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) return forms[1];
  return forms[2];
};

export const FilePlate = (props: FilePlateProps) => {
  const errors = props.errors?.map((error) => (
    <>
      <ErrorText key={error}>{error}</ErrorText>
      <br />
    </>
  ));
  const batchFileSize = useMemo(
    () => props.files.reduce((previousValue, currentValue) => previousValue + currentValue.file.size, 0) / bytesInMiB,
    [props.files],
  );

  const preparedFiles = props.files.map((fileRecord, index) => (
    <FilePlateBox isError={fileRecord.isErrored} key={fileRecord.operationId}>
      <>
        <FilePlateCloseButton
          onClick={() => {
            props.onRemove?.(fileRecord.operationId);
          }}
        />

        <FileName title={fileRecord.file.name}>{fileRecord.file.name}</FileName>
        <FilePlatePreviewIcon filename={fileRecord.file.name} isLoading={fileRecord.isLoading} />
      </>
    </FilePlateBox>
  ));
  return (
    <>
      {!!props.files.length && (
        <>
          <FilePlateWrap>{preparedFiles}</FilePlateWrap>
          <Space size={12} axis={'vertical'} />
          <TotalFilesInfo>{`${props.files.length} ${pluralizeFiles(props.files.length)} (${batchFileSize.toFixed(
            2,
          )} МБ) `}</TotalFilesInfo>
          <DeleteAllFiles onClick={() => props.onRemove?.(null)}>{'Удалить все'}</DeleteAllFiles>
          <Space size={4} axis={'vertical'} />
          {errors}
        </>
      )}
    </>
  );
};
